export const VAT_TYPES = {
  VAT: "VAT",
  INCL: "INCL",
  EXCL: "EXCL",
};

export default function calculateVAT(type, amount, rate = 0.15) {
  if (type.length === 0) {
    console.warn("CalculateVAT: required 'type' not provided.");
    return 0;
  }
  if (amount === 0) {
    console.warn("CalculateVAT: required 'amount' cannot be 0.");
    return 0;
  }
  if (rate === 0) {
    console.warn("CalculateVAT: required 'rate' cannot be 0.");
    return 0;
  }
  switch (type) {
    case VAT_TYPES.VAT:
      return amount * rate
    case VAT_TYPES.INCL:
      return amount * (1 + rate)
    case VAT_TYPES.EXCL:
      return amount / (1 + rate)
    default:
      console.warn("CalculateVAT: required 'type' not matched.");
      return 0;
  }
}
